import { useDispatch, useSelector } from 'react-redux'
import { State } from 'src/state'
import { patchCurrentUser } from 'src/state/users'
import { UserPatchType } from '@meniudigital/shared'
import Setting from '../Setting'

export default function MaintenanceSetting() {
  const dispatch = useDispatch()
  const { user } = useSelector((state: State) => state.users)

  if (!user) {
    return null
  }

  const confirmToggle = async () => {
    if (!user.inMaintenanceMode) {
      await window.showModal({
        title: `Dezactivare meniu`,
        text: `Ești sigur că dorești dezactivarea completă a meniului tău?\n\nNotă: actualizarea în Google poate dura 1-2 zile atât la dezactivarea, cât și la reactivarea meniului.`,
        confirmButtonText: 'Da, dezactivează',
        cancelButtonText: 'Nu',
      })
    } else {
      await window.showModal({
        title: `Activare meniu`,
        text: `Ești sigur că dorești reactivarea meniului tău?\n\nImportant: reapariția meniului în rezultatele Google nu este imediată. Motoarele de căutare au nevoie de 1-2 zile pentru a-și actualiza indexul, așa că meniul poate lipsi din rezultate o perioadă scurtă după reactivare.`,
        confirmButtonText: 'Da, reactivează',
        cancelButtonText: 'Nu',
      })
    }
  }

  const toggleMaintenanceMode = async () => {
    if (!user.inMaintenanceMode) {
      const payload = {
        type: UserPatchType.InMaintenanceMode,
        data: true,
      }
      dispatch(patchCurrentUser(payload as any))
      await window.showConfirm({ text: `Meniul tău a fost dezactivat.` })
    } else {
      const payload = {
        type: UserPatchType.InMaintenanceMode,
        data: false,
      }
      dispatch(patchCurrentUser(payload as any))
      await window.showConfirm({ text: `Meniul tău a fost reactivat.` })
    }
  }

  return (
    <Setting
      title="Disponibilitate Meniu"
      icon={
        <img
          src="/logo.svg"
          alt="QR Code icon"
          style={user.inMaintenanceMode ? { filter: 'saturate(0)' } : {}}
        />
      }
      isEnabled={!user?.inMaintenanceMode}
      onBeforeToggle={confirmToggle}
      onToggle={toggleMaintenanceMode}
      toggleTexts={{ on: 'Accesibil', off: 'Indisponibil' }}
      infoText="Prin dezactivare, accesarea meniului tău (prin URL sau cod QR) nu va mai fi posibilă."
      infoVariant="error"
      alwaysShowsBody
      withBullet
    />
  )
}
